import React from "react";
// import Button from "@material-ui/core/Button";
import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";

import Form, { formTypes } from "./../../Forms/Containers/FormCreator";

function SelectCity(props) {
  return (
    <>
      <div>
        <div className="page-title" style={{fontWeight:'bold'}}>{LANDING_MENU_BAR.COMMUNAL_FILE}</div>
      </div>
      <div className="container-content">
        <div className="content-line input-div">
          <Form
            onChange={props.handlerSubmit}
            objectCreator={[
              {
                type: formTypes.select,
                label: "Comuna",
                placeholder: "Seleccione una opción",
                required: true,
                classContainer: "center-div",
                classLabel: "input-text",
                // classInput: "form-control",
                variable: "city",
                keyValue: "dane",
                keyText: "nombre",
                data: props.data
              }
            ]}
            onSubmit={props.handlerSubmit}
          />
        </div>
      </div>
    </>
  );
}

export default SelectCity;
